exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-99911cc4],.fade-leave-active[data-v-99911cc4]{transition:opacity .3s}.fade-enter[data-v-99911cc4],.fade-leave-to[data-v-99911cc4]{opacity:0}.popup-modal[data-v-99911cc4]{background-color:rgba(0,0,0,.2);position:fixed;top:0;bottom:0;left:0;right:0;padding:.5rem;display:flex;align-items:center;z-index:1111}.window[data-v-99911cc4]{background:#4a4a4a;border-radius:5px;box-shadow:2px 3px 12px rgba(0,0,0,.3);max-width:480px;margin-left:auto;margin-right:auto;padding:1rem}", ""]);

// exports
